import css from "standard/css";

const style = css`
  .filter {
    display: flex;
    gap: var(--spacing_inset-xs);
  }

  .filter__class {
    border: var(--border-width-hairline) solid var(--color-ocean);
    background-color: transparent;
    border-radius: 100px;
    color: var(--color-ocean);
    cursor: pointer;
    font-size: var(--font-size-xxs);
    font-weight: var(--font-weight-medium);
    font-family: var(--font-family-highlight);
    padding: var(--spacing_inset-xs) var(--spacing_inset-sm); 
  }

  .filter__class:focus {
    background-color: var(--color-ocean);
    color: var(--color-pure-white);
  }
`;

export default style;
